import { ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthorizationCanActivateGuard } from './core/guards/authorization.guard';
import { AuthenticationCanActivateGuard } from './core/guards/authentication.guard';
import { AuthorizationService } from './shared/services/authorization.service';
import { OIDCConfigService } from './shared/services/oidc-config.service';
import { AuthInterceptor } from './core/interceptors/auth-interceptor.service';
import { AdminAuthorizationCanActivateGuard } from './core/guards/admin.authorization.guard';
import { APP_BASE_HREF } from '@angular/common';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { IncognitoService } from './shared/services/incongito-helper';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    AuthorizationCanActivateGuard,
    AuthenticationCanActivateGuard,
    AdminAuthorizationCanActivateGuard,
    AuthorizationService,
    OIDCConfigService,
    BrowserAnimationsModule,
    provideAnimations(),
    {
      provide: APP_INITIALIZER,
      useFactory: (oidcConfigService: OIDCConfigService) => () => oidcConfigService.load(),
      deps: [OIDCConfigService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (incognitoService: IncognitoService) => () => incognitoService.detect(),
      deps: [IncognitoService],
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: APP_BASE_HREF, useValue: '/' },
  ],
};
